import React, {PureComponent} from 'react';

import Biome from './biome';
import Ocean from './ocean';
import Terrain from './terrain';

export default class PlanetTile extends PureComponent {
    render() {
        const {
                biomeId,
                center,
                elevation,
                radius,
                noise,
                normal,
                point,
                random,
                region
            } = this.props,
            altitude = radius + (noise * elevation);
        return <group>
            <Terrain altitude={altitude} biomeId={biomeId} center={center} point={normal} region={region}/>
            <Ocean noise={noise} point={normal} radius={radius} region={region}/>
            <Biome key="biome" altitude={altitude} biomeId={biomeId} point={point} random={random}/>
        </group>;
    }
}


// WEBPACK FOOTER //
// ./src/apps/scene-planet/scene/planet/tile.js